import { AudienceInstance, AudienceType } from '@/client/services/api/graphql/gql/graphql';
import { Avatar, Circle, Icon, Tag, TagCloseButton } from '@chakra-ui/react';
import { IoGitNetworkOutline, IoLocationOutline } from 'react-icons/io5';

import { GoOrganization } from 'react-icons/go';
import { HiOutlineUserGroup } from 'react-icons/hi2';
import { IconType } from 'react-icons/lib';
import { LiaUserGraduateSolid } from 'react-icons/lia';

interface AssignmentSegmentationTagProps {
  item: AudienceInstance;
  handleRemoveItem: (id: AudienceInstance) => void;
}

export default function AssignmentSegmentationTag({
  item,
  handleRemoveItem,
}: AssignmentSegmentationTagProps) {
  const typeIconMap: { [key: string]: IconType } = {
    location: IoLocationOutline,
    department: IoGitNetworkOutline,
    team: HiOutlineUserGroup,
    org_level: GoOrganization,
    grade: LiaUserGraduateSolid,
    group: HiOutlineUserGroup,
  };

  return (
    <Tag key={item.id} variant="create">
      {item.type === AudienceType.User && (
        <Avatar marginRight={2} size="xs" name={item.name} src={item.image as string} />
      )}

      {/* @ts-ignore */}
      {(item.type === AudienceType.Segment || item.type === 'segment') && (
        <Circle size="20px" backgroundColor="warmNeutral.200" marginRight={2}>
          <Icon as={typeIconMap[item.segmentationType]} />
        </Circle>
      )}

      {item.name}

      <TagCloseButton onClick={() => handleRemoveItem(item)} />
    </Tag>
  );
}
